import { IDmChuyenNganh } from "../../../model/respone/category/IDmChuyenNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmChuyenNganhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmChuyenNganh[],
  LOAD_ERRR: "",
};
export const eDmChuyenNganhActionIds = generateActionTypeIds(
  eDmChuyenNganhActionsObj,
  "CHUYEN_NGANH"
);
export type IDmChuyenNganhActionTypes = IGenericActionType<
  typeof eDmChuyenNganhActionsObj,
  "CHUYEN_NGANH"
>;
